import 'dayjs/plugin/relativeTime'

import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import { observer } from 'mobx-react-lite'
import { Trans } from '@lingui/react/macro'

import type { PhotosApi } from '@jotta/types/PhotosApi'
import type { BoxPropsAs } from '@jotta/ui/Box'
import { LoadingOverlay } from '@jotta/ui/LoadingOverlay'

import { NoSharedPhotos } from '../NoSharedPhotos/NoSharedPhotos'

import { SharedPhotosPageRow } from './SharedPhotosPageRow'

import styles from './SharedPhotosPage.module.scss'

dayjs.extend(advancedFormat)

export interface SharedPhotosPageProps extends BoxPropsAs {
  albums?: readonly PhotosApi.AlbumInfo[]
  isLoading?: boolean
}

export const SharedPhotosPage = observer<SharedPhotosPageProps>(
  function SharedPhotosPage({ albums, isLoading = false }) {
    const showLoadingOverlay = isLoading
    const showEmpty = Boolean(!showLoadingOverlay && albums && !albums.length)
    const showAlbumList = typeof albums !== 'undefined' && albums.length > 0

    return (
      <>
        <LoadingOverlay
          id="SharedPhotosPage"
          position="absolute"
          open={showLoadingOverlay}
        />
        {showEmpty && <NoSharedPhotos />}
        {showAlbumList && (
          <div className={styles.grid}>
            <h2>
              <Trans>Photos</Trans>
            </h2>
            <h2>
              <Trans>Content</Trans>
            </h2>
            <h2>
              <Trans>Created</Trans>
            </h2>
            <h2>
              <Trans>Link</Trans>
            </h2>
            {albums.map(album => (
              <SharedPhotosPageRow key={album.id} album={album} />
            ))}
          </div>
        )}
      </>
    )
  },
)
